// @ts-check
import { useQuery } from '@tanstack/react-query';
import api from '../api';

/**
 * @param {import('club-sauce/public/support/index.raw').LWApiPublicSupportPhoneNumbersParamsRawI} params
 * @param {import('@tanstack/react-query').UseQueryOptions} options
 */
const useSupportPhoneNumbers = (params, { enabled } = {}) =>
	useQuery({
		queryKey: ['/support/phoneNumbers', params],
		queryFn: () => api.support.apiRaw.phoneNumbers(params),
		enabled,
	});

export default useSupportPhoneNumbers;
